
(function(){
 function initDesktop(){
  document.querySelectorAll('[data-clstudio]').forEach(function(root){
   if(root.dataset.ready)return;root.dataset.ready='1';
   var slides=Array.from(root.querySelectorAll('[data-clstudio-slide]')),buttons=Array.from(root.querySelectorAll('[data-clstudio-to]')),index=0;
   if(!slides.length)return;
   function go(n){index=(n+slides.length)%slides.length;slides.forEach(function(s,i){s.hidden=i!==index});buttons.forEach(function(b,i){b.setAttribute('aria-current',i===index?'true':'false')})}
   buttons.forEach(function(b,i){b.addEventListener('click',function(){go(i)})});go(0);
   if(root.dataset.autoplay==='true'&&slides.length>1&&!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    setInterval(function(){if(document.visibilityState==='visible'&&!root.matches(':hover')&&!root.contains(document.activeElement))go(index+1)},Math.max(4000,(Number(root.dataset.delay)||6)*1000))
   }
  });
 }
 function init(){initDesktop()}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init)
})();
